export default __webpack_public_path__ + "static/media/factory__39.d3052abf.jpg";